module.exports = __webpack_public_path__ + "assets/astra.c09d0a61.svg";